angular.module('swapick')
.directive('objectFeedback', objectFeedback)
.directive('feedbackStars', feedbackStars)

function objectFeedback(){
    return {
        scope : { object : "=", currentUser:"=", 'askForFeedback':"="},
        restrict: 'A',
        templateUrl : 'templates/object_feedback.html',
        link: function (scope, iElement, iAttrs) {

          scope.getFeedbackForUid = (obj, uid) => {
            if(!obj.esiti) return null;
            let o =  _.find(obj.esiti, e => e.utente == uid );
            return o;

          }


        }
    };
}


function feedbackStars($timeout){
    return {
        scope : { value : "=", starClasses:"=", writable:"="},
        restrict: 'A',
        templateUrl : 'templates/object_feedback_stars.html',

        link: function (scope, iElement, iAttrs) {
          scope.stars = [1,2,3,4,5].map(i=>{
            return { cls : 'star-empty'  }
          })
          scope.$watch('value', (nv)=>{
            scope.intValue = parseInt(nv);
            _.each(scope.stars, (star, idx) => {
              if(idx < scope.intValue ){
                scope.stars[idx].cls = 'star-full'
              } else {
                scope.stars[idx].cls = 'star-empty'
              }
            })
          })

          scope.clickStar = idx => {
            if(!scope.writable){
              return
            }
            $timeout(()=>{
              scope.value = idx + 1;
            })
          }


        }
    };
}



// WEBPACK FOOTER //
// ./src/directives/object-feedback.js